export const consultationConstants = {
    SET_CALL_FINISHED: 'SET_CALL_FINISHED'
};
